import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const useDeviceType = () => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isLargeDesktop = useMediaQuery(theme.breakpoints.up("xl"));

    return {
        isMobile,
        isTablet,
        isDesktop,
        isSmallMobile,
        isLargeDesktop,
        isMobileOrTablet: isMobile || isTablet,
        isTabletOrDesktop: isTablet || isDesktop,
    };
};
